import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import { getAuthorByName, getAuthorBySlug } from 'Components/Blog/content/AuthorData';
import FixedImg from 'Components/Utility/FixedImg';

import 'Components/Blog/content/BlogAuthorBio.scss';

const BlogAuthorBio = ({ authorName, authorSlug, isHomePage }) => {
  let authorData;

  if (authorName) authorData = getAuthorByName(authorName);
  if (authorSlug) authorData = getAuthorBySlug(authorSlug);

  if (!authorData) return false;

  return (
    <div className="BlogAuthorBio">

      <div className={classNames('BlogAuthorBio_profilePicture', { isHomePage })}>
        {authorData?.profilePic ?
          <FixedImg
            src={authorData.profilePic}
            folder="assets/blog/authors"
            alt={authorName}
            width="70"
          />
          :
          <FontAwesomeIcon icon={faUser} />
        }
      </div>

      <div className="BlogAuthorBio_content">
        {isHomePage &&
          <h1 className="BlogAuthorBio_authorName">{authorData?.name}</h1>
        }
        {!isHomePage &&
          <Link to={`/blog/authors/${authorData?.authorSlug}`} className="BlogAuthorBio_authorName_link">
            {authorData?.name}
          </Link>
        }
        <div className="BlogAuthorBio_authorBio">
          {authorData?.bio}
        </div>
      </div>
    </div>
  );
};

BlogAuthorBio.propTypes = {
  authorName: PropTypes.string,
  authorSlug: PropTypes.string,
  isHomePage: PropTypes.bool, // is the component located on the home page
};

BlogAuthorBio.defaultProps = {
  authorName: '',
  authorSlug: '',
  isHomePage: false,
};


export default BlogAuthorBio;
